import { render, staticRenderFns } from "./EventProfile.vue?vue&type=template&id=0f2be13e&scoped=true&"
import script from "./EventProfile.vue?vue&type=script&lang=js&"
export * from "./EventProfile.vue?vue&type=script&lang=js&"
import style0 from "./EventProfile.vue?vue&type=style&index=0&id=0f2be13e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f2be13e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
installComponents(component, {VBtn,VCard,VChip})
